export const theme = {
  primary: "#0b0c10",
  textColor: "#F0FFF0"
};
